<template>
<div class="swipe-activity-wrapper vertical">
  <div class="flex flex-col h-full items-center content-center justify-center relative">
    <div class="swipeup">
      <div class="flex flex-col">
        <div class="w-40">Swipe Up or <br>Up Arrow Key</div>
        <div class="font-bold pt-3">More Stress</div>
      </div>
    </div>

    <vue-swing
      @throwoutdown="onDownThrowout"
      @throwoutup="onUpThrowout"
      :config="config"
      ref="vueswing"
      class="swipe-item-wrapper"
    >
      <div
        v-for="(card, index) in cards"
        :id="card.id"
        class="swipe-item flex-col"
        :style="wasSwipedWithKeyboard(card) ? {
          opacity: '0%',
          transform: 'translateY(' + (150 * wasSwipedWithKeyboard(card)) + 'px) !important',
          transitionProperty: 'transform,opacity !important',
          transitionDuration: '200ms !important',
        } : {
          opacity: '100%',
        }"
      >
        <input id="swipeselected" class="w-0 h-0 text-xxs p-0 m-0 opacity-0 hidden lg:block"
        v-if="index == cards.length - 1"
          tabindex="0"
          autofocus="autofocus"
          onfocus="this.select()"
          :value="card.attributes['description'].text"
        >
        <h4 v-if="card.attributes['title']" class="font-bold">{{ card.attributes['title'].text }}</h4>

        <p>{{ card.attributes['description'].text }}</p>
      </div>
    </vue-swing>

    <div class="swipedown">
      <div class="flex flex-col">
        <div class="w-40">Swipe Down or <br>Down Arrow Key</div>
        <div class="font-bold pt-3">Less Stress</div>
      </div>
    </div>
      <div class="submit-button-wrapper" v-if="maybemearray.length === itemcount || maybemearray.length < 1" >
        <span class="text-xs text-white">Please try again with more variation</span>
        <button ref="restart" @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart<i aria-hidden="true" class="material-icons align-middle text-3xl">refresh</i></button>
      </div>
      <div class="submit-button-wrapper" v-else >
        <div v-if="demo !== ('1')">
          <button ref="submit" @click="submitResults" type="submit" class="submitResults px-5 py-2">Next<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>
        <div v-else>
          <button ref="restart" @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
      </div>
  </div>
</div>
</template>

<script>
import VueSwing from 'vue-swing'
import axios from 'axios'

export default {
  components: { VueSwing },
  props: {
      array: '',
      labels: '',
      route:'',
      count:'',
      demo:'',
  },
  data() {
    return {
      leftChosen: false,
      rightChosen: false,
      cards: this.array,
      itemcount: this.count,
      notmearray: [],
      maybemearray: [],
      labelsarray: this.labels,
      config: {
        allowedDirections: [
          VueSwing.Direction.UP,
          VueSwing.Direction.DOWN
        ],
        minThrowOutDistance: 250,
        maxThrowOutDistance: 300
      },
      cardSwipedWithKeyboard: null,
      cardSwipedDirection: null,
    }
  },
  methods: {
    add () {
      this.cards.push(`${this.cards.length + 1}`)
    },
    remove () {
      this.swing()
      setTimeout(() => {
        this.cards.pop()
      }, 100)
    },
    swing () {
      const cards = this.$refs.vueswing.cards
      cards[cards.length - 1].throwOut(
        Math.random() * 100 - 50,
        Math.random() * 100 - 50
      )
    },
    wasSwipedWithKeyboard(card) {
      if (card && this.cardSwipedWithKeyboard) {
        return card.id === this.cardSwipedWithKeyboard.id ? this.cardSwipedDirection : false;
      }
    },
    swipeWithKeyboard(direction) {
      const cards = this.$refs.vueswing.cards;
      this.cardSwipedWithKeyboard = this.cards[this.cards.length - 1];
      this.cardSwipedDirection = direction;

      if (this.cards.length == 1) {
        this.focusOnSubmitButton();
      }

      if (! this.cardSwipedWithKeyboard) {
        this.focusOnSubmitButton();
        return;
      }

      setTimeout(() => {
        if (cards[cards.length - 1]) {
          cards[cards.length - 1].throwOut(0, direction);
        }
      }, 200);
    },
    keyUpArrow () {
      this.swipeWithKeyboard(-1);
    },
    keyDownArrow () {
      this.swipeWithKeyboard(1);
    },
    focusOnSubmitButton() {
      this.$nextTick(() => {
        if (this.$refs.restart) {
          this.$refs.restart.focus();
        } else if (this.$refs.submit) {
          this.$refs.submit.focus();
        }
      });
    },
    restartActivity() {
      $( ".submitResults").addClass( "loading" );
      location.reload();
    },
    onDownThrowout ({ target, throwDirection }) {
        setTimeout(() => {
          this.cards.pop()
          target.className += " notme";
        }, 1)
      console.log(`Less Stress ${target.textContent}!`)
    },
    onUpThrowout ({ target, throwDirection }) {
      this.maybemearray.unshift(target.id);
      this.cards.pop();
      target.className += " maybeme";
      console.log(`More Stress ${target.textContent}!`)
    },
    submitResults: function (event) {
      $( ".submitResults").addClass( "loading" );
      axios.put(this.route, {
        results: this.maybemearray
      }).then(function (response) {
          console.log(response);
        }).then(function (event) {
          location.reload();
        })
    },
    handleKeyup(event) {
      if (event.keyCode == 38) {
        this.keyUpArrow();
      }

      if (event.keyCode == 40) {
        this.keyDownArrow();
      }
    },
  },
  created() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>
